import React, {PropTypes, Component} from 'react';
import classnames from 'classnames';

import './App.css';

export default class About extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

    render() {
        const {className, ...props} = this.props;
        return (
            <div className={classnames('About', className)} {...props}>
                <div style={styles.topDiv}>
                    Developing websites, iOS and Android apps using React, Javascript, Java, Swift, Objective-C
                </div>
            </div>
        );
    }
}

const styles = {
    // flexContainer: {
    //     display: 'flex',
    //     flexDirection: 'column',
    //     justifyContent: 'space-between',
    // },
    topDiv: {
        marginTop: 20,
    },
};


// WEBPACK FOOTER //
// ./src/About.js